<template>
  <div class="container-fluid">
    <h1>Orders Awaiting Payment</h1>
    <b-table
      striped hover class="wide-table"
      :items="fishbowlAwaitingPayment" :fields="columns"
      sort-by.sync="DateCreated" :sort-desc="false"
    >
      <template slot="OrderNum" slot-scope="data">
        <router-link :to="{ name: 'View Order', params: { id: data.item.OrderNum }}" target="_blank" >
          {{ data.item.OrderNum }}
        </router-link>
      </template>
      <template slot="workareaDetails" slot-scope="data">
        <b-button
          v-if="data.item.OrderNum.toLowerCase().startsWith('e')"
          @click="showModal(data.item)"
        >
          Workarea Details
        </b-button>
        <div v-else>
          Not on Workarea
        </div>
      </template>
      <template slot="DateCreated" slot-scope="data">
        <NiceDate :value="data.item.DateCreated" split="true" />
      </template>
    </b-table>

    <b-modal ref="workareaDetailsModal" hide-footer title="Workarea Details">
      <div class="d-block">
        <b-row class="align-items-center">
          <b-col cols="5">
            <span class="big text-monospace">
              {{ modalData.fishbowl.OrderNum }}
            </span>
          </b-col>
          <b-col v-if="this.workareaSalesOrder.exists">
            <b-button
              v-if="this.modalData.fishbowl.OrderNum"
              variant="outline-info" size="sm" target="_blank"
              :href="'https://www.andymark.com/admin/orders/' + this.modalData.fishbowl.OrderNum.toUpperCase()"
            >
              Open Website Order
            </b-button>
          </b-col>
          <b-col v-if="this.workareaSalesOrder.exists">
            <b-button
              v-if="this.workareaSalesOrder.user_id"
              variant="outline-primary" size="sm" target="_blank"
              :href="'https://www.andymark.com/admin/users/' + this.workareaSalesOrder.user_id"
            >
              Open Website Customer
            </b-button>
          </b-col>
        </b-row>
        <hr />

        <p v-if="workareaSalesOrder && workareaSalesOrder.orderNotes">
          <h5>Customer Order Comments</h5>
          <span v-html="workareaSalesOrder.orderNotes" />
         <hr />
        </p>

        <p
          v-if="workareaCustomerDetails && workareaCustomerDetails.data &&
          workareaCustomerDetails.data.comments &&
          workareaCustomerDetails.data.comments.length">
          <h5>Customer Account Private Notes:</h5>
          <p v-for="comment in workareaCustomerDetails.data.comments">
            <strong>{{ comment.updated_at | moment("MMMM D, YYYY") }} :</strong>
            <span v-html="comment.body"></span>
          </p>
          <hr />
        </p>
        <p v-if="workareaSalesOrder && workareaSalesOrder.orderPrivateNotes && workareaSalesOrder.orderPrivateNotes.length">
          <h5>Order Private Notes:</h5>
          <p v-for="comment in workareaSalesOrder.orderPrivateNotes">
            <strong>{{ comment.updated_at | moment("MMMM D, YYYY") }} :</strong>
            <span v-html="comment.body"></span>
          </p>
          <hr />
        </p>
      </div>
      <b-btn class="mt-3" variant="outline-danger" block @click="hideModal">
        Close
      </b-btn>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import dateFormat from 'dateformat';
import NiceDate from '../../utility/NiceDate';

export default {
  data() {
    return {
      columns: [{
        key: 'DateCreated',
        sortable: true,
      }, {
        key: 'OrderNum',
        sortable: true,
      }, {
        key: 'PaymentMethod',
        sortable: true,
      }, {
        key: 'TotalPrice',
        sortable: true,
      }, {
        key: 'carrier',
        sortable: true,
      }, {
        key: 'orderNotes',
        name: 'Order Notes',
        sortable: true,
      }, {
        key: 'workareaDetails',
        name: 'Workarea Details',
        sortable: false,
      },
      ],
      modalData: {
        fishbowl: {},
        workareaOrder: {},
        workareaCustomer: {},
      }
    };
  },
  components: {
    NiceDate,
  },
  computed: {
    ...mapGetters({
      fishbowlAwaitingPayment: 'fishbowlAwaitingPayment',
      workareaSalesOrder: 'workareaSalesOrder',
      workareaCustomerDetails: 'workareaCustomerDetails',
    }),
  },
  methods: {
    ...mapActions({
      getfishbowlAwaitingPayment: 'getFishbowlAwaitingPayment',
      clearWorkareaOrder: 'clearWorkareaOrder',
      getWorkareaOrder: 'getWorkareaOrder',
      getCustomerDetails: 'getCustomerDetails',
    }),
    showModal(data) {
      console.log('data', data);
      this.clearWorkareaOrder().then( () => {
        this.modalData = {
          fishbowl: {},
          workareaOrder: {},
          workareaCustomer: {},
        };
        this.getWorkareaOrder(data.OrderNum).then( (wa) => {
          this.modalData.workareaOrder = this.workareaSalesOrder;
          this.modalData.fishbowl = data;
          console.log(this.modalData.fishbowl);
          this.$refs.workareaDetailsModal.show();
        });
      });
    },
    hideModal() {
      this.$refs.workareaDetailsModal.hide();
      this.modalData = {
        fishbowl: {},
        workareaOrder: {},
        workareaCustomer: {},
      };
    },
  },
  watch: {
    workareaSalesOrder: function(newW, old) {
        if (this.workareaSalesOrder && this.workareaSalesOrder.email) {
          this.getCustomerDetails(this.workareaSalesOrder.email);
        }
    },
  },
  mounted() {
    this.getfishbowlAwaitingPayment();
    this.getCustomerDetails();
    setInterval(() => { this.getFishbowlAwaitingPayment(); }, 1000 * 90);
  },
};
</script>

<style>
  .wide-table {
    margin-top: 1rem;
  }

  .wide-table th, .wide-table td {
    max-width: 50vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/sales-order/reports/AwaitingPayment.vue